module.exports = __webpack_public_path__ + "img/img (40).a3e3aed8.png";